import React from "react";
import PropTypes from "prop-types";

import { Button, Flex, Text } from "shipnow-mercurio";

import { Styles } from "./MessagePageLayout.styles";

const DEFAULT_PROPS = {
  cancelButtonProps: null,
  confirmButtonProps: null,
  imageProps: null,
  margin: "a-0",
  padding: "a-0",
  subText: "",
  text: "",
  title: "",
};

export const MessagePageLayout = (props) => {
  //? merge default attrs with attrs.
  const attrs = {
    ...DEFAULT_PROPS,
    ...props,
  };
  return (
    <Styles.Wrapper margin={attrs.margin} padding={attrs.padding}>
      {!!attrs.imageProps && <Styles.ImageWrapper {...attrs.imageProps} />}

      {!!attrs.title && (
        <Text align="center" margin="t-32" size="title">
          {attrs.title}
        </Text>
      )}

      {!!attrs.text && (
        <Styles.Description align="center">{attrs.text}</Styles.Description>
      )}

      {!!attrs.subText && (
        <Text align="center" color="blackDisabled" margin="t-16">
          {attrs.subText}
        </Text>
      )}

      <Flex>
        {!!attrs.cancelButtonProps && (
          <Button
            type="outlined"
            margin="y-24 r-8"
            {...attrs.cancelButtonProps}
          />
        )}

        {!!attrs.confirmButtonProps && (
          <Button margin="y-24" {...attrs.confirmButtonProps} />
        )}
      </Flex>
    </Styles.Wrapper>
  );
};

MessagePageLayout.propTypes = {
  cancelButtonProps: PropTypes.object,
  confirmButtonProps: PropTypes.object,
  imageProps: PropTypes.object,
  margin: PropTypes.string,
  padding: PropTypes.string,
  subText: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string,
};
